export const ALL_PATH ={
    video_path:"https://musicisvivid.s3.amazonaws.com/uploads/user_uploaded_videos/",
    profile_image_path:"https://musicisvivid.s3.amazonaws.com/uploads/profile_pictures/",
    cover_pictures:"https://musicisvivid.s3.amazonaws.com/uploads/cover_pictures/",
    album_pictures:"https://musicisvivid.s3.amazonaws.com/uploads/album_pictures/",
    playist_pictures:"https://musicisvivid.s3.amazonaws.com/uploads/playlist_pictures/",
    user_uploaded_musics:"https://musicisvivid.s3.amazonaws.com/uploads/user_uploaded_musics/",
    user_contest_music : "https://musicisvivid.s3.amazonaws.com/uploads/user_contest_music/",
    genre_image_link : "https://miv.musicisvivid.com/uploads/genre_images/"
   }

   // export const ALL_PATH ={
   //  video_path:"https://musicisvividdev.s3.us-west-2.amazonaws.com/uploads/user_uploaded_videos/",
   //  profile_image_path:"https://musicisvividdev.s3.us-west-2.amazonaws.com/uploads/profile_pictures/",
   //  cover_pictures:"https://musicisvividdev.s3.us-west-2.amazonaws.com/uploads/cover_pictures/",
   //  album_pictures:"https://musicisvividdev.s3.us-west-2.amazonaws.com/uploads/album_pictures/",
   //  playist_pictures:"https://musicisvividdev.s3.us-west-2.amazonaws.com/uploads/playlist_pictures/",
   //  user_uploaded_musics:"https://musicisvividdev.s3.us-west-2.amazonaws.com/uploads/user_uploaded_musics/",
   //  user_contest_music : "https://musicisvividdev.s3.us-west-2.amazonaws.com/uploads/user_contest_music/",
   //  genre_image_link : "https://musicisvividdev.s3.us-west-2.amazonaws.com/genre_images/"
   // }